
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/kirjaudu",
      function () {
        return require("private-next-pages/auth/kirjaudu.js");
      }
    ]);
  